import { doPost, doDelete, doGet } from './fetch.service';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import { FileState, FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { ResponseError } from 'sos-common/js/utils/ResponseError';

export interface IPostFileServerResponse {
  FileId: string;
  ComplementaryId: string;
  OriginalFilename: string;
}

export interface IPostFileResponse<T> {
  serverResponse: T;
  fileUploadValue: FileExtendedDetails[];
}

export interface IPostFile {
  FileId: string;
}

/* 
    Posts a single file to backend.
    Expects a type T that must extend IPostFile to return. 
  */
export function postFile<T extends IPostFile>(
  file: FormFieldFile,
  apiEndpoint: string,
  formData: FormData
): Promise<IPostFileResponse<T> | ResponseError> {
  const notSettled = file.value.filter((f) => f.status !== FileState.SETTLED)[0];
  formData.append(notSettled.OriginalFilename, notSettled.file);

  return doPost<T>(apiEndpoint, formData).then((response) => {
    if (response instanceof ResponseError) return response;

    const settledFile = { ...notSettled };
    settledFile.status = FileState.SETTLED;
    settledFile.FileId = response.FileId;
    const files = file.value.map((file) => {
      if (!file.FileId) return settledFile;
      return file;
    });

    return { serverResponse: response, fileUploadValue: files };
  });
}

/* 
    Get all files for a specific fileupload component from backend. 
    Expects a type T to return. 
  */
export function getFiles<T>(apiEndpoint: string): Promise<T | ResponseError> {
  return doGet<T>(apiEndpoint).then((response) => {
    return response;
  });
}

/* 
    Deletes a single file from backend.
  */
export function deleteFile(apiEndpoint: string, formData: FormData): Promise<string | ResponseError> {
  return doDelete<string>(apiEndpoint, formData).then((response) => {
    return response;
  });
}
